import type { EFavoriteType } from '@domain/Customer';

export interface IListFavoritesEndpointResponse {
  list: {
    id: string;
    title: string;
    type: EFavoriteType;
  }[];
}

export const listFavoritesEndpoint = () => '/customers/favorites';
